var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overflow-y-scroll w-100" }, [
    _c(
      "div",
      {
        staticClass: "container-fluid outage-strategy-view",
        attrs: { id: "outage-strategy-container" },
      },
      [
        _c("loading", {
          attrs: { active: _vm.loading, "can-cancel": false },
          on: {
            "update:active": function ($event) {
              _vm.loading = $event
            },
          },
        }),
        !_vm.data.selected.unit
          ? _c(
              "div",
              {
                staticClass: "alert alert-danger text-center",
                attrs: { role: "alert" },
              },
              [
                _c("h2", { staticClass: "text-danger" }, [
                  _vm._v(" " + _vm._s(_vm.$t("pleaseSelectUnit")) + " "),
                ]),
              ]
            )
          : _vm._e(),
        !_vm.data.navBarRefresh && _vm.data.selected.unit
          ? _c("div", [
              _c("div", { staticClass: "row my-3" }, [
                _c("div", { staticClass: "col-12 text-center" }, [
                  _c("h2", { staticClass: "title my-0" }, [
                    _vm._v(" " + _vm._s(_vm.$t("outageStrategy")) + " "),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "row my-2" }, [
                _c("div", { staticClass: "col-12 text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary",
                      on: {
                        click: function ($event) {
                          return _vm.exportOutageStrategyPdf()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("export")) + " ")]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 table-wrapper" }, [
                  _c("table", { staticClass: "table text-center" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", { attrs: { rowspan: "2" } }),
                        _c("th", { attrs: { rowspan: "2" } }, [
                          _c("span", { staticClass: "no-wrap" }, [
                            _vm._v(_vm._s(_vm.$t("plantName"))),
                          ]),
                          _vm._v(" / "),
                          _c("span", { staticClass: "no-wrap" }, [
                            _vm._v(_vm._s(_vm.$t("unitName"))),
                          ]),
                        ]),
                        _c("th", { attrs: { rowspan: "2" } }, [
                          _vm._v(" " + _vm._s(_vm.$t("outageTitle")) + " "),
                        ]),
                        _c("th", { attrs: { rowspan: "2" } }, [
                          _vm._v(" " + _vm._s(_vm.$t("outageId")) + " "),
                        ]),
                        _c("th", { attrs: { rowspan: "2" } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("duration")) +
                              " (" +
                              _vm._s(_vm.$t("days")) +
                              ")"
                          ),
                          _c("br"),
                          _c("br"),
                          _vm._v(" " + _vm._s(_vm.$t("planned"))),
                          _c("br"),
                          _c("span", { staticClass: "nominated" }, [
                            _vm._v(_vm._s(_vm.$t("nominated"))),
                          ]),
                        ]),
                        _c("th", { attrs: { rowspan: "2" } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("outageStrategyExtension")) +
                              " "
                          ),
                          _c("span", { staticClass: "no-wrap" }, [
                            _vm._v(
                              "(" +
                                _vm._s(_vm.$t("days")) +
                                " / " +
                                _vm._s(_vm.$t("outageStrategyProbability")) +
                                ")"
                            ),
                          ]),
                          _c("br"),
                          _c("br"),
                          _vm._v(" " + _vm._s(_vm.$t("estimated"))),
                          _c("br"),
                        ]),
                        _c("th", { attrs: { rowspan: "2" } }, [
                          _vm._v(" " + _vm._s(_vm.$t("cost")) + " "),
                        ]),
                        _c("th", { attrs: { rowspan: "2" } }, [
                          _vm._v(" " + _vm._s(_vm.$t("cost")) + " / EOH "),
                        ]),
                        _c(
                          "th",
                          {
                            staticClass: "border-right",
                            attrs: { rowspan: "2" },
                          },
                          [
                            _vm._v(" " + _vm._s(_vm.$t("outageDate"))),
                            _c("br"),
                            _c("br"),
                            _vm._v(" " + _vm._s(_vm.$t("planned"))),
                            _c("br"),
                            _c("span", { staticClass: "nominated" }, [
                              _vm._v(_vm._s(_vm.$t("nominated"))),
                            ]),
                          ]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "leading-item-title",
                            attrs: { colspan: "6" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("leadingItem")) + " ")]
                        ),
                      ]),
                      _c("tr", [
                        _c("th", { staticClass: "leading-item-sub-title" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("outageDateCalculated")) + " "
                          ),
                        ]),
                        _c("th", { staticClass: "leading-item-sub-title" }, [
                          _vm._v(" " + _vm._s(_vm.$t("plantItem")) + " "),
                        ]),
                        _c("th", { staticClass: "leading-item-sub-title" }, [
                          _vm._v(" " + _vm._s(_vm.$t("driver")) + " "),
                        ]),
                        _c("th", { staticClass: "leading-item-sub-title" }, [
                          _vm._v(" " + _vm._s(_vm.$t("interval")) + " "),
                        ]),
                        _c("th", { staticClass: "leading-item-sub-title" }, [
                          _vm._v(" " + _vm._s(_vm.$t("pleLimit"))),
                          _c("br"),
                          _vm._m(0),
                        ]),
                        _c("th", { staticClass: "leading-item-sub-title" }, [
                          _vm._v(" " + _vm._s(_vm.$t("actualValue")) + " "),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.outageStrategy.items, function (item) {
                          return _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.outageStrategy.items &&
                                    _vm.outageStrategy.items.length,
                                  expression:
                                    "outageStrategy.items && outageStrategy.items.length",
                                },
                              ],
                              key: item.id,
                            },
                            [
                              item.outageYear && item.outagesInYear
                                ? _c(
                                    "td",
                                    {
                                      staticClass: "outage-year",
                                      attrs: { rowspan: item.outagesInYear },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(item.outageYear)),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _c("td", [
                                _vm._v(
                                  _vm._s(item.plantName) +
                                    " / " +
                                    _vm._s(item.unitName)
                                ),
                              ]),
                              _c("td", [_vm._v(_vm._s(item.outageTitle))]),
                              _c("td", [_vm._v(_vm._s(item.outageId))]),
                              _c("td", [
                                _vm._v(" " + _vm._s(item.plannedDuration)),
                                _c("br"),
                                _c("span", { staticClass: "nominated" }, [
                                  _vm._v(_vm._s(item.nominatedDuration)),
                                ]),
                              ]),
                              _c("td", [
                                item.outageExtensionDays
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(item.outageExtensionDays) +
                                          " / " +
                                          _vm._s(
                                            item.outageExtensionProbability
                                          ) +
                                          "%"
                                      ),
                                    ])
                                  : _c("span", [_vm._v("-")]),
                              ]),
                              _c("td", { staticClass: "no-wrap" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(item.cost) +
                                    " K" +
                                    _vm._s(item.currency) +
                                    " "
                                ),
                              ]),
                              _c("td", [_vm._v(_vm._s(item.costPerEoh))]),
                              _c("td", { staticClass: "border-right" }, [
                                _c("span", { staticClass: "no-wrap" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDate")(item.nextPlannedDate)
                                    )
                                  ),
                                ]),
                                _c("br"),
                                _c(
                                  "span",
                                  { staticClass: "nominated no-wrap" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDate")(
                                          item.nextNominatedDate
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                              !item.leadingItem
                                ? _c("td", { attrs: { colspan: "6" } }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.$t("outageHasNoLeadingItem"))
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              item.leadingItem
                                ? _c("td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            item.leadingItem.nextCalculatedDate
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              item.leadingItem
                                ? _c("td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.leadingItem.plantItem) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              item.leadingItem
                                ? _c("td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.leadingItem.driver) +
                                        " "
                                    ),
                                    item.leadingItem.driver2
                                      ? _c("span", [
                                          _vm._v(
                                            " / " +
                                              _vm._s(item.leadingItem.driver2)
                                          ),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                              item.leadingItem
                                ? _c("td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.leadingItem.interval) +
                                        " "
                                    ),
                                    item.leadingItem.interval2
                                      ? _c("span", [
                                          _vm._v(
                                            " / " +
                                              _vm._s(item.leadingItem.interval2)
                                          ),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                              item.leadingItem
                                ? _c("td", [
                                    _c(
                                      "div",
                                      { staticClass: "row flex-nowrap" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "ple-limits" },
                                          [
                                            item.leadingItem.p80Limit
                                              ? _c(
                                                  "span",
                                                  { staticClass: "p-80-label" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.leadingItem
                                                            .p80Limit
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            item.leadingItem.p80Limit2
                                              ? _c(
                                                  "span",
                                                  { staticClass: "p-80-label" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.leadingItem
                                                            .p80Limit2
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "ple-limits" },
                                          [
                                            item.leadingItem.p50Limit
                                              ? _c(
                                                  "span",
                                                  { staticClass: "p-50-label" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.leadingItem
                                                            .p50Limit
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            item.leadingItem.p50Limit2
                                              ? _c(
                                                  "span",
                                                  { staticClass: "p-50-label" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.leadingItem
                                                            .p50Limit2
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              item.leadingItem
                                ? _c("td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.leadingItem.actualValue) +
                                        " "
                                    ),
                                    item.leadingItem.actualValue2
                                      ? _c("span", [
                                          _vm._v(
                                            " / " +
                                              _vm._s(
                                                item.leadingItem.actualValue2
                                              )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        }),
                        _c(
                          "tr",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  !_vm.outageStrategy.items ||
                                  !_vm.outageStrategy.items.length,
                                expression:
                                  "!outageStrategy.items || !outageStrategy.items.length",
                              },
                            ],
                          },
                          [
                            _c("td", { attrs: { colspan: "15" } }, [
                              _vm._v(" " + _vm._s(_vm.$t("noOutages")) + " "),
                            ]),
                          ]
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "filter-show",
                  class: { "visible-button": _vm.filterVisible },
                  on: {
                    click: function ($event) {
                      return _vm.toggleFilter()
                    },
                  },
                },
                [
                  _c("div", { staticClass: "content" }, [
                    _c(
                      "span",
                      [
                        _vm._v(" " + _vm._s(_vm.$t("filter")) + " "),
                        _c("font-awesome-icon", {
                          attrs: { icon: "angle-down" },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "filter-container pt-2 pb-2 pl-2 pr-2",
                  class: [{ visible: _vm.filterVisible }],
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "max-height": "700px",
                        "overflow-x": "hidden",
                        "overflow-y": "auto",
                      },
                    },
                    [
                      _c("h6", [
                        _vm._v(
                          _vm._s(_vm.$t("plant")) +
                            " / " +
                            _vm._s(_vm.$t("unit"))
                        ),
                      ]),
                      _c("div", { staticClass: "mb-2" }, [
                        _c("div", { staticClass: "form-check pl-0 mb-3" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectAllPlants,
                                expression: "selectAllPlants",
                              },
                            ],
                            staticClass: "form-check-input",
                            attrs: { type: "checkbox", id: "all-filter" },
                            domProps: {
                              checked: Array.isArray(_vm.selectAllPlants)
                                ? _vm._i(_vm.selectAllPlants, null) > -1
                                : _vm.selectAllPlants,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.selectAllPlants,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.selectAllPlants = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.selectAllPlants = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.selectAllPlants = $$c
                                  }
                                },
                                function ($event) {
                                  return _vm.onSelectAllChange(
                                    _vm.selectAllPlants
                                  )
                                },
                              ],
                            },
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label",
                              attrs: { for: "all-filter" },
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("selectAll"))),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.filter.plants, function (plant, index) {
                          return _c(
                            "div",
                            {
                              key: "plantFilter-" + index,
                              staticClass: "col-auto mb-2",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form-check pl-0",
                                  staticStyle: { "border-bottom": "1px solid" },
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: plant.selected,
                                        expression: "plant.selected",
                                      },
                                    ],
                                    staticClass: "form-check-input",
                                    attrs: {
                                      id: index + "-plant-filter",
                                      type: "checkbox",
                                    },
                                    domProps: {
                                      checked: Array.isArray(plant.selected)
                                        ? _vm._i(plant.selected, null) > -1
                                        : plant.selected,
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$a = plant.selected,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  plant,
                                                  "selected",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  plant,
                                                  "selected",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(plant, "selected", $$c)
                                          }
                                        },
                                        function ($event) {
                                          return _vm.onPlantFilterChange(
                                            $event,
                                            plant
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "form-check-label",
                                      attrs: { for: index + "-plant-filter" },
                                    },
                                    [_c("strong", [_vm._v(_vm._s(plant.name))])]
                                  ),
                                ]
                              ),
                              _c(
                                "ul",
                                { staticClass: "list-unstyled" },
                                _vm._l(plant.units, function (unit) {
                                  return _c(
                                    "li",
                                    { key: index + "-" + unit.machineSID },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-check pl-0" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: unit.selected,
                                                expression: "unit.selected",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              id:
                                                unit.machineSID +
                                                "-unit-filter",
                                              type: "checkbox",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                unit.selected
                                              )
                                                ? _vm._i(unit.selected, null) >
                                                  -1
                                                : unit.selected,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a = unit.selected,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          unit,
                                                          "selected",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          unit,
                                                          "selected",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      unit,
                                                      "selected",
                                                      $$c
                                                    )
                                                  }
                                                },
                                                function ($event) {
                                                  return _vm.onUnitFilterChange(
                                                    $event,
                                                    plant,
                                                    unit
                                                  )
                                                },
                                              ],
                                            },
                                          }),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "form-check-label",
                                              attrs: {
                                                for:
                                                  unit.machineSID +
                                                  "-unit-filter",
                                              },
                                            },
                                            [_vm._v(_vm._s(unit.name))]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _c("hr", { staticClass: "mt-0 mb-1" }),
                      _c("h6", [_vm._v(_vm._s(_vm.$t("maintenanceActivity")))]),
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(
                          _vm.filter.maintenanceActivities,
                          function (maintenanceActivity) {
                            return _c(
                              "div",
                              {
                                key: maintenanceActivity.id,
                                staticClass: "col-auto mb-2",
                              },
                              [
                                _c("div", { staticClass: "form-check pl-0" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: maintenanceActivity.selected,
                                        expression:
                                          "maintenanceActivity.selected",
                                      },
                                    ],
                                    staticClass: "form-check-input",
                                    attrs: {
                                      type: "checkbox",
                                      id:
                                        maintenanceActivity.id +
                                        "-maintenance-type-filter",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        maintenanceActivity.selected
                                      )
                                        ? _vm._i(
                                            maintenanceActivity.selected,
                                            null
                                          ) > -1
                                        : maintenanceActivity.selected,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = maintenanceActivity.selected,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                maintenanceActivity,
                                                "selected",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                maintenanceActivity,
                                                "selected",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            maintenanceActivity,
                                            "selected",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "form-check-label",
                                      attrs: {
                                        for:
                                          maintenanceActivity.id +
                                          "-maintenance-type-filter",
                                      },
                                    },
                                    [_vm._v(_vm._s(maintenanceActivity.name))]
                                  ),
                                ]),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                      _c("hr"),
                      _c(
                        "div",
                        { staticClass: "input-group input-group-sm mb-2" },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c("span", { staticClass: "input-group-text" }, [
                              _vm._v(_vm._s(_vm.$t("outageIds"))),
                            ]),
                          ]),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.filter.selectedOutageId,
                                  expression: "filter.selectedOutageId",
                                },
                              ],
                              staticClass: "form-control",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.filter,
                                    "selectedOutageId",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c("option", { domProps: { value: null } }, [
                                _vm._v(" " + _vm._s(_vm.$t("none")) + " "),
                              ]),
                              _vm._l(_vm.filter.outageIds, function (id) {
                                return _c(
                                  "option",
                                  { key: id, domProps: { value: id } },
                                  [_vm._v(" " + _vm._s(id) + " ")]
                                )
                              }),
                            ],
                            2
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "input-group input-group-sm mb-2" },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c("span", { staticClass: "input-group-text" }, [
                              _vm._v(_vm._s(_vm.$t("costGreaterOrEqualTo"))),
                            ]),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: _vm.filter.minimumCost,
                                expression: "filter.minimumCost",
                                modifiers: { number: true },
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "number", min: "0" },
                            domProps: { value: _vm.filter.minimumCost },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.filter,
                                  "minimumCost",
                                  _vm._n($event.target.value)
                                )
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                          _vm._m(1),
                        ]
                      ),
                      _c("div", { staticClass: "input-group input-group-sm" }, [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("span", { staticClass: "input-group-text" }, [
                            _vm._v(
                              _vm._s(_vm.$t("showOnlyOutagesWithLeadingItem"))
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "input-group-append" }, [
                          _c("div", { staticClass: "input-group-text" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.filter.showOnlyOutagesWithLeadingItem,
                                  expression:
                                    "filter.showOnlyOutagesWithLeadingItem",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.filter.showOnlyOutagesWithLeadingItem
                                )
                                  ? _vm._i(
                                      _vm.filter.showOnlyOutagesWithLeadingItem,
                                      null
                                    ) > -1
                                  : _vm.filter.showOnlyOutagesWithLeadingItem,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a =
                                      _vm.filter.showOnlyOutagesWithLeadingItem,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.filter,
                                          "showOnlyOutagesWithLeadingItem",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.filter,
                                          "showOnlyOutagesWithLeadingItem",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.filter,
                                      "showOnlyOutagesWithLeadingItem",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                  _c("hr"),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-link btn-sm float-left",
                      on: {
                        click: function ($event) {
                          return _vm.clearAllFilters()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("clearAllFilters")) + " ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm mt-1",
                      on: {
                        click: function ($event) {
                          return _vm.refresh()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("filter")) + " ")]
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "legend row flex-nowrap justify-content-center" },
      [
        _c("span", { staticClass: "p-80-label" }, [_vm._v("P80")]),
        _vm._v(" "),
        _c("span", { staticClass: "p-50-label" }, [_vm._v("P50")]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c(
        "span",
        { staticClass: "input-group-text", staticStyle: { width: "30px" } },
        [_vm._v("K")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }